import React from "react";
import ReactDOM from "react-dom/client";
import { BoxPlot } from "./components/BoxPlot";
import { BoundaryBar } from "./components/BoundaryBar";
import App from "./App";
import "./App.css"; // Nur App.css für WordPress

document.addEventListener("DOMContentLoaded", () => {
  console.log("MAIN.TSX: DOM loaded, starting initialization");
  console.log("MAIN.TSX: Current URL:", window.location.href);
  console.log("MAIN.TSX: Document body:", document.body);

  // Check for development environment (index.html with #root)
  const devRootElement = document.getElementById("root");
  console.log("MAIN.TSX: devRootElement found:", !!devRootElement);
  console.log("MAIN.TSX: devRootElement:", devRootElement);
  if (devRootElement) {
    console.log("MAIN.TSX: Development mode detected, importing index.css");
    // Development: Load index.css for standalone app styling
    import("./index.css")
      .then(() => {
        console.log("MAIN.TSX: index.css loaded, rendering App");
        // Development: Render full App in #root
        const root = ReactDOM.createRoot(devRootElement);
        console.log("MAIN.TSX: ReactDOM root created, rendering...");
        root.render(
          <React.StrictMode>
            <App />
          </React.StrictMode>
        );
        console.log("MAIN.TSX: App rendered successfully");
      })
      .catch((err) => {
        console.error("MAIN.TSX: Failed to load index.css:", err);
      });
  } else {
    // WordPress: Only load App.css (component styles)
    // index.css is NOT loaded to avoid conflicts with WordPress themes
    console.log("MAIN.TSX: WordPress mode detected");

    const boxplotElements = document.querySelectorAll(".box-plot-visualizer");
    console.log(
      "MAIN.TSX: Found",
      boxplotElements.length,
      "WordPress elements"
    );

    boxplotElements.forEach((element) => {
      const markerPercent = parseFloat(
        element.getAttribute("data-marker-percent") || "2.8"
      );
      const quartileRangeX = parseFloat(
        element.getAttribute("data-quartile-range-x") || "0.47"
      );
      const quartileRangeWidth = parseFloat(
        element.getAttribute("data-quartile-range-width") || "2.6"
      );
      const quartileMainX = parseFloat(
        element.getAttribute("data-quartile-main-x") || "1.19"
      );
      const quartileMainWidth = parseFloat(
        element.getAttribute("data-quartile-main-width") || "0.4"
      );

      // Get boundary bars array from data attribute
      const boundaryBarsAttr = element.getAttribute("data-boundary-bars");
      let boundaryBars: Array<{
        name: string;
        label?: string;
        marker_percent: number;
        arrows: string;
        show_left_arrows: number;
        show_right_arrows: number;
        dotted_line_start: number | null;
        dotted_line_end: number | null;
      }> = [];

      if (boundaryBarsAttr) {
        try {
          boundaryBars = JSON.parse(boundaryBarsAttr);
          console.log("MAIN.TSX: Parsed boundary bars:", boundaryBars);
        } catch (e) {
          console.error("MAIN.TSX: Failed to parse boundary bars JSON:", e);
          // Fallback to default
          boundaryBars = [
            {
              name: "Freshwater Change",
              label: "",
              marker_percent: 1.6,
              arrows: "none",
              show_left_arrows: 0,
              show_right_arrows: 0,
              dotted_line_start: null,
              dotted_line_end: null,
            },
          ];
        }
      } else {
        // Fallback to default
        boundaryBars = [
          {
            name: "Freshwater Change",
            label: "",
            marker_percent: 1.6,
            arrows: "none",
            show_left_arrows: 0,
            show_right_arrows: 0,
            dotted_line_start: null,
            dotted_line_end: null,
          },
        ];
      }

      const root = ReactDOM.createRoot(element as HTMLElement);
      root.render(
        <React.StrictMode>
          <div className="box-plot-visualizer-grid">
            <BoxPlot
              markerPercent={markerPercent}
              quartileRangeX={quartileRangeX}
              quartileRangeWidth={quartileRangeWidth}
              quartileMainX={quartileMainX}
              quartileMainWidth={quartileMainWidth}
            />
            <div className="boundary-bars-grid">
              {boundaryBars.map((bar, index) => {
                // Process dotted line if provided (pass raw 0-4 values)
                let dottedLine: [number, number] | undefined = undefined;
                if (
                  bar.dotted_line_start !== null &&
                  bar.dotted_line_end !== null
                ) {
                  const start = bar.dotted_line_start;
                  const end = bar.dotted_line_end;
                  // Explizite Validierung für 0-Werte
                  if (
                    typeof start === "number" &&
                    typeof end === "number" &&
                    !isNaN(start) &&
                    !isNaN(end) &&
                    start >= 0 &&
                    end >= 0 &&
                    start <= 4 &&
                    end <= 4
                  ) {
                    dottedLine = [start, end];
                  }
                }

                return (
                  <BoundaryBar
                    key={index}
                    markerPercent={bar.marker_percent}
                    name={bar.name}
                    nameLabel={bar.label} // ← Diese Zeile hinzufügen
                    showLeftArrows={Boolean(bar.show_left_arrows)}
                    showRightArrows={Boolean(bar.show_right_arrows)}
                    dottedLine={dottedLine}
                  />
                );
              })}
            </div>
          </div>
        </React.StrictMode>
      );
    });
  }
});
